<template>
  <div class="name-input-area">
    <div class="rows">
      <div :class="{'cols-sm-4':useMiddleName,'cols-sm-6':!useMiddleName}">
        <input v-model="inputVal.firstName" class="form-control" :placeholder="$t('column.nm.first_name')" type="text">
        <div class="clear" />
      </div>
      <div v-if="useMiddleName" class="cols-sm-4">
        <input v-model="inputVal.middleName" class="form-control" :placeholder="$t('column.nm.middle_name')" type="text">
        <div class="clear" />
      </div>
      <div :class="{'cols-sm-4':useMiddleName,'cols-sm-6':!useMiddleName}">
        <input v-model="inputVal.lastName" class="form-control" :placeholder="$t('column.nm.last_name')" type="text">
        <div class="clear" />
      </div>
      <div class="clear" />
    </div>
    <div class="clear" />
  </div>
</template>

<script>
export default {
  props: {
    name: {
      type: String,
      default: ''
    },
    useMiddleName: {
      type: Boolean,
      default: true
    },
    readonly: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    value: {
      type: String,
      default: undefined
    }
  },
  data() {
    return {
      inputVal: {
        firstName: '',
        middleName: '',
        lastName: ''
      }
    }
  },
  watch: {
    value: {
      handler: function(newVal) {
        if (newVal) {
          const names = newVal.split(';')
          this.inputVal.firstName = decodeURIComponent(names[0])
          this.inputVal.middleName = decodeURIComponent(names[1])
          this.inputVal.lastName = decodeURIComponent(names[2])
        } else {
          this.inputVal = {
            firstName: '',
            middleName: '',
            lastName: ''
          }
        }
      },
      immediate: true
    },
    inputVal: {
      handler: function(newVal) {
        let val
        if (this.inputVal) {
          let firstName
          let middleName
          let lastName

          firstName = newVal.firstName
          middleName = newVal.middleName
          lastName = newVal.lastName

          if (!firstName) {
            firstName = ''
          }
          if (!middleName) {
            middleName = ''
          }
          if (!lastName) {
            lastName = ''
          }
          if (!firstName && !middleName && !lastName) {
            this.$emit('input', '')
            this.$emit('change', '')
            return
          }
          val =
            encodeURIComponent(firstName) +
            ';' +
            encodeURIComponent(middleName) +
            ';' +
            encodeURIComponent(lastName)
          this.$emit('input', val)
          this.$emit('change', val)
        }
      },
      deep: true
    }
  },
  methods: {
    hasError(name) {
      return this.errors.has(name)
    }
  }
}
</script>

<style scoped>
.name-input-area {
  min-height: 49px;
}
</style>
